import { ACTION_TYPES } from '../../actions';

const INIT_STATE = {
  menuList: [],
  menuObj: {}
};

/**
  * 将菜单列表层级展开成对象形式存储
  * @param {Array} menuList 菜单列表
  */
function processMenuObj(menuList) {
  const menuObj = {};
  const flattenMenu = (menus) => {
    menus.forEach((menuNode) => {
      const { id, parentId, menuLink, menuName, subMenuList } = menuNode;
      menuObj[id] = { id, parentId, menuLink, menuName };
      if (subMenuList && subMenuList.length) {
        flattenMenu(subMenuList);
      }
    });
  }
  flattenMenu(menuList);

  return menuObj;
}

export default function menu(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  switch (type) {
    // 获取菜单列表
    case ACTION_TYPES.GET_MENU_LIST:
      result.menuList = payload;
      result.menuObj = processMenuObj(payload);
      break;
    default:
      result = state;
  }
  return result;
}
